import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import * as authActions from 'redux/modules/auth';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {RxForm, FormManager, Checkbox, FormField} from 'reactis-forms';
import {TextInput} from 'reactis-inputs';

@connect(
	state => ({...state.password}),
	authActions)
export default class Login extends Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object
	};

	constructor() {
		super();
		this.schema = {
			password: {
				class: TextInput,
				type: 'password',
				autoFocus: true,
				autoComplete: 'off',
				placeholder: 'Heslo',
				className: 'form-control password',
				label: 'Heslo',
				rules: {
					presence: {message: 'Zadejte heslo!'}
				}
			},
			passwordConfirm: {
				class: TextInput,
				type: 'password',
				autoComplete: 'off',
				className: 'form-control password',
				placeholder: 'Heslo pro kontrolu',
				label: 'Heslo pro kontrolu',
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			},
		};
		this.form = new FormManager(this.schema);
	}

	handleSubmit() {
		const values = this.form.getValues().toJS();
		this.props.setPassword(this.props.token, values.password).then((result) => {
			if (!result.error) {
				this.props.login({username: this.props.email, password: values.password}).then((result) => {
					if (!result.error) {
						this.context.router.push('/')
					}
				});
			}
		});
	}

	handleBack(e) {
		e.preventDefault();
		this.context.router.push('/login');
	}

	render() {

		return (
			<RxForm ref="form" id="setpassword" form={this.form} className="form-login" onSubmit={() => this.handleSubmit()}>
				<div className="panel panel-body login-form">
						<div className="text-center">
							<div className="icon-object border-slate-300 text-slate-300">
								<i className="icon-key"></i>
							</div>
							<h5 className="content-group">Zadejte nové heslo
								<small className="display-block">{this.props.email}</small>
							</h5>
						</div>

						{this.props.error && <div className="errorHandler alert alert-danger">
							{this.props.error}
						</div>}

						<div className="form-group has-feedback has-feedback-left">
								<FormField name="password"/>
								<div className="form-control-feedback">
									<i className="icon-lock2 text-muted"></i>
								</div>
						</div>
						<div className="form-group has-feedback has-feedback-left">
							<FormField name="passwordConfirm"/>
							<div className="form-control-feedback">
								<i className="icon-lock2 text-muted"></i>
							</div>
						</div>
						<div className="form-group">
							<button type="submit" className="btn bg-blue btn-block">Nastavit heslo <i className="icon-arrow-right14 position-right"></i></button>
						</div>

						<div className="col-sm-12 text-right">
							<a href="/login" onClick={(e) => this.handleBack(e)}>&lt; zpět na přihlášení</a>
						</div>
				</div>
			</RxForm>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Login/SetPassword.js